import React from 'react';
import { Select } from 'antd';
const { Option } = Select;

const SelectMultiple = props => {
  const { field: { schema }, input: { value, onChange } } = props
  const enum_key = schema && schema.enums || []
  const enum_title = schema && schema.enum_title || []
  const values_type = (schema && schema.values_type) ? schema.values_type == 'object' : false
  const ops = enum_key.map((key, i) => ({ id: key, name: enum_title ? enum_title[i] : key }))

  function handleChange(value) {
    if (values_type && enum_title) {
      const vals = value.map(key => (ops.filter(item => item.id == key)[0]))
      onChange(vals)
    } else {
      onChange(value)
    }
  }

  return (
    <Select
      mode="multiple"
      onChange={handleChange}
      style={{ width: '100%' }}
      placeholder={schema.title + '...'}
      // getPopupContainer={triggerNode => triggerNode.parentNode || document.body}
      value={((values_type && value) ? value.map(item => item.id) : value) || undefined}
    >
      {ops.map((item) => (<Option key={item.id}>{item.name}</Option>))}
    </Select>
  )
}

export default SelectMultiple
